<template>
  <div class="loader">
    <fa-icon icon="spinner" class="loader__spinner" spin></fa-icon>
  </div>
</template>

<script>
export default {
name: "Loader"
}
</script>
